import { jsx as c } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import g from "../../../../core/Context/useCoreContext.js";
import { TableCells as h } from "./TableCells.js";
import { Fragment as y } from "../../../../external/preact/dist/preact.module.js";
import { noop as a } from "../../../../utils/common.js";
const C = ({
  data: l,
  columns: n,
  customCells: u,
  onRowHover: o
}) => {
  const { i18n: s } = g();
  return /* @__PURE__ */ c(y, { children: l == null ? void 0 : l.map((r, p) => /* @__PURE__ */ c(
    "div",
    {
      role: "row",
      tabIndex: 0,
      className: "adyen-pe-data-grid__row",
      onMouseEnter: s.has(`tooltip.${r == null ? void 0 : r.category}`) && o ? () => o(p) : a,
      onFocus: s.has(`tooltip.${r == null ? void 0 : r.category}`) && o ? () => o(p) : a,
      onMouseLeave: s.has(`tooltip.${r == null ? void 0 : r.category}`) && o ? () => o() : a,
      onBlur: s.has(`tooltip.${r == null ? void 0 : r.category}`) && o ? () => o() : a,
      children: /* @__PURE__ */ c(h, { columns: n, customCells: u, item: r, rowIndex: p })
    },
    r
  )) });
};
export {
  C as TableBody
};
